module.exports = __webpack_public_path__ + "img/1_04.24ec916e.jpg";